import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useTheme } from '../../context/ThemeContext'
import { capitalizeInitialOnly } from '../../helper-functions/CapitalizeName'
import { getRecipients } from '../../services/envelopes'
import Skeleton from 'react-loading-skeleton'

type Props = {
    showModal: boolean
    closeModal: () => void
    envelope: any

}

const ViewEnvelopeRecepient: React.FC<Props> = ({
    showModal,
    closeModal,
    envelope,
}: Props) => {
    const { theme } = useTheme()
    const [recipients, setRecipients] = useState<any[]>([])
    const [loading, setLoading] = useState<boolean>(false)
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        const fetchRecipients = async () => {
            setLoading(true)
            if (envelope?.envelopeId) {
                setError(null)
                try {
                    const response = await getRecipients(envelope.envelopeId)
                    setRecipients(response?.data?.data?.recipients?.signers || [])
                } catch (err: any) {
                    setError(err?.message || 'Failed to fetch recipients')
                    // console.error('Error fetching recipients:', err)
                } finally {
                    setLoading(false)
                }
            }
        }

        if (showModal) {
            fetchRecipients()
        }
    }, [envelope?.envelopeId, showModal])

    return (
        <Modal
            contentClassName={`${theme === 'dark' ? 'theme__div' : ''}`}
            show={showModal}
            onHide={closeModal}
        >
            <Modal.Header>
                <Modal.Title
                    className={`text-truncate ${theme === 'dark' ? 'theme__div' : ''}`}
                >{`View "${envelope?.documentName?.trim()}"`}</Modal.Title>
                <i className={`bi bi-x-lg modal-icon-custom ${theme === 'dark' && 'close'}`} onClick={closeModal}></i>

            </Modal.Header>
            <Modal.Body>

                <span className={theme === 'dark' ? 'white__text w-full' : ' w-full'}>
                    <div className='d-flex justify-content-between align-items-center gap-2 '>
                        <span> Envelope was sent to:</span>
                        {/* <span> {capitalizeInitialOnly(envelope?.status)}</span> */}
                    </div>
                    {loading ? (
                        Array.from({ length: 3 }, (key:any) => (
                            <div key={key}> <Skeleton count={1} height={25} /></div>
                        ))
                    ) : error ? (
                        <div className='my-2 text-danger'>{error}</div>
                    ) : (
                        <ul className='my-2 text-italic'>
                            {recipients && recipients?.length > 0 ? (
                                recipients?.map((recipient: any, index: number) => (
                                    <div className='d-flex justify-content-between gap-3' key={index}>
                                        <li>
                                            <span>  {recipient.email}</span>
                                        </li>
                                        <span>  {capitalizeInitialOnly(recipient.status || 'Pending')}</span>
                                    </div>
                                ))
                            ) : (
                                <li>No recipients found</li>
                            )}
                        </ul>
                    )}
                </span>

            </Modal.Body>

        </Modal>
    )
}

export default ViewEnvelopeRecepient
